import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 52,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    '&.Mui-checked': {
      transform: 'translateX(29px) translateY(-11px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#4CAF50', // Color del track cuando está activo
        opacity: 1,
        border: '1px solid white', // Añade borde blanco para crear el hueco
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 22,
    height: 22,
    boxShadow: 'none', // Elimina cualquier sombra del thumb
  },
  '& .MuiSwitch-track': {
    borderRadius: 16, // Asegúrate que los bordes del track son completamente redondos
    backgroundColor: theme.palette.grey[400], // Color del track cuando está inactivo
    opacity: 1,
    boxSizing: 'border-box', // Asegúrate que el borde es parte del tamaño total del track
  },
}));

export default IOSSwitch;
